import Imm from 'immutable';
import { createSelector } from 'reselect';
import mapping from '~/utils/mapping.json';


export const getRoot = state => state.get('organizations') || state;

export const getOrgData = state => getRoot(state).get('data');

export const hasData = state => !getOrgData(state).isEmpty();

const formFields = [
    'author_id',
    'name',
    'vanity',
    'organization_type_id',
    'description',
    'contact',
    'address',
    'portal',
    'private',
    'closed',
    'show_impact_meter',
    'allow_offline',
    'allow_private_groups',
    'allow_shoutbox',
    'disable_email_notifications',
    'offline_opps_require_contact',
    'general_opportunity_enabled',
    'bypass_content_moderation',
    'student_graduation_required',
    'licenses',
    'duns',
    'url',
    'phone',
    'deleted',
    'archived',
    'portal_affiliates',
    'enable_share_portal',
    'enable_private_collaboratory_feature',
    'office_name',
    'email',
    'proxy_a_i',
    'ai_reporting_chat_enabled',
    'report_widget_tool_enabled',
    'manage_fields_enabled',
];

export const getInitialFormData = createSelector(
    getOrgData,
    data => (data.isEmpty()
        ? data
        : formFields.reduce((res, i) => res.set(i, data.get(i)), Imm.Map())),
);

export const getOrgID = state => getOrgData(state).get('id');

export const getLicenses = createSelector(
    state => getOrgData(state).get('licenses') || Imm.List(),
    licenses => licenses
        .filterNot(l => l.get('deleted'))
        .map(l => ({
            id: l.get('id'),
            product: mapping.license.by_id[l.getIn(['product', 'id'])],
            description: l.getIn(['product', 'description']),
        })),
);
